import { useCallback, useEffect, useState } from 'react';

import api from '~/services/api';
import { IDictionaryTypes } from '~/services/api/dictionaries/types';
import { extractErrorMessage } from '~/utils/error/error';
import formatDictionaryOptions from '~/utils/formatDictionaryOptions';

import type { ILocalAdminDictionaryOptions } from '../types';

type ShowErrorFn = (message: string) => void;

const useLocalAdminDictionaryOptions = (showError: ShowErrorFn) => {
  const [options, setOptions] = useState<ILocalAdminDictionaryOptions | null>(null);
  const [dictLoading, setDictLoading] = useState(true);

  const load = useCallback(async () => {
    try {
      setDictLoading(true);
      const [states, credentials, educations, employmentStatuses, subRoles] = await Promise.all([
        api.dictionaries
          .getAvailableTypeList(IDictionaryTypes.State)
          .then(r => formatDictionaryOptions(r.data)),
        api.dictionaries
          .getAvailableTypeList(IDictionaryTypes.Credentials)
          .then(r => formatDictionaryOptions(r.data)),
        api.dictionaries
          .getAvailableTypeList(IDictionaryTypes.Education)
          .then(r => formatDictionaryOptions(r.data)),
        api.dictionaries
          .getAvailableTypeList(IDictionaryTypes.EmploymentStatus)
          .then(r => formatDictionaryOptions(r.data)),
        api.dictionaries
          .getAvailableTypeList(IDictionaryTypes.SubRole)
          .then(r => formatDictionaryOptions(r.data)),
      ]);
      setOptions({ states, credentials, educations, employmentStatuses, subRoles });
    } catch (e) {
      showError(extractErrorMessage(e));
    } finally {
      setDictLoading(false);
    }
  }, [showError]);

  useEffect(() => {
    load();
  }, [load]);

  return { options, dictLoading };
};

export default useLocalAdminDictionaryOptions; // eslint-disable-line import/no-unused-modules
